'use client';

import React from 'react';
import { useTranslations } from 'use-intl';

// Visually hidden link that becomes visible only when keyboard-focused.
// Skips screen-reader / keyboard users past the page chrome (header,
// nav, ad bar) straight to the page's main content. Sits at the top of
// the layout, before any visible chrome.
//
// The target is whatever element has id="main-content" — Frontastic's
// renderer adds it to the `main` section.
const SkipToContent = () => {
  const translate = useTranslations();

  return (
    <a
      href="#main-content"
      className="bg-primary text-14 sr-only rounded-br px-4 py-2 font-semibold text-white focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50"
    >
      {translate('common.skip-to-content')}
    </a>
  );
};

export default SkipToContent;
